import {
  ISourceDetailsRaw,
  ISourceDetailsData,
  ISourcePackageData,
} from '../../../types';

/**
 * Format the response of the inbound source details
 */
export function formatSourceDetailsResponse(
  data: ISourceDetailsRaw
): ISourceDetailsData {
  const { multiLocationInventories, source, total } = data;
  const { store } = source;
  const { name, address1, address2, city, country } = store;
  const completeAddress = `${address1}, ${address2}, ${city}, ${country}`;

  const storeInfo = {
    name,
    address: completeAddress,
  };

  const storePackageData: ISourcePackageData[] = multiLocationInventories?.map(
    (inventory) => {
      const { location, inventories } = inventory;
      return {
        title: location === 'HISTORY' ? 'History' : 'Today',
        data: inventories,
      };
    }
  );

  return {
    storeInfo,
    storePackageData,
    total,
  };
}
